import React from 'react';
import { ImageAndExpandableListV2 } from 'types/studio/studio';
import { Typography, getTypographyDefaultColor } from '@ag1/ui';
import styles from './NumbersSection.module.scss';

type Props = {
  numbersOptions: ImageAndExpandableListV2['numbersOptions'];
  theme: ImageAndExpandableListV2['theme'];
};

const NumbersSection = ({ numbersOptions, theme }: Props) => {
  const { addNumbers, numbers } = numbersOptions || {};

  if (!addNumbers && !Array.isArray(numbers)) {
    return null;
  }

  return (
    <div className={styles.root}>
      {numbers?.map((item) => (
        <div key={item._key} className={styles.item}>
          <Typography
            variant="headlineSans"
            size="2"
            noPadding
            color={getTypographyDefaultColor(theme)}
            className={styles.number}>
            {item.number}
          </Typography>
          <Typography
            variant="body"
            size="1"
            noPadding
            color={getTypographyDefaultColor(theme)}
            weight="700"
            className={styles.description}>
            {item.description}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default NumbersSection;
